/**
 * Deficiency Helper Utilities
 * 
 * Shared utilities for handling deficiency data in report rows
 */

/**
 * Check if a report row has a valid deficiency
 * Handles both string IDs and populated deficiency objects
 * 
 * @param {string|object} deficiencyId - The deficiency ID or populated object
 * @returns {boolean} - True if valid deficiency exists
 */
export const hasDeficiency = (deficiencyId) => {
  try {
    if (!deficiencyId) {
      return false;
    }
    
    if (typeof deficiencyId === 'string') {
      return deficiencyId.trim() !== '';
    }
    
    if (typeof deficiencyId === 'object' && deficiencyId._id) {
      return (
        typeof deficiencyId._id === 'string' &&
        deficiencyId._id.trim() !== ''
      );
    }
    
    console.warn('[deficiencyHelpers] Invalid deficiencyId format:', deficiencyId);
    return false;
  } catch (err) {
    console.error('[deficiencyHelpers] Error checking deficiency:', err);
    return false;
  }
};

/**
 * Get a deficiency object suitable for the DeficiencyIcon component
 * Converts string IDs to minimal objects with _id field
 * 
 * @param {string|object} deficiencyId - The deficiency ID or populated object
 * @returns {object|null} - Deficiency object with at least _id field, or null
 */
export const getDeficiencyForIcon = (deficiencyId) => {
  try {
    if (!deficiencyId) {
      return null;
    }
    
    if (typeof deficiencyId === 'string') {
      return { _id: deficiencyId };
    }
    
    if (typeof deficiencyId === 'object' && deficiencyId._id) {
      return deficiencyId;
    }
    
    console.warn(
      '[deficiencyHelpers] Cannot create deficiency object from:',
      deficiencyId
    );
    return null;
  } catch (err) {
    console.error('[deficiencyHelpers] Error creating deficiency object:', err);
    return null;
  }
};
